import { isNullish } from "./nullish";

export const hasErrorMessage = (
  error: { message: unknown } | object
): error is { message: string } =>
  "message" in error && typeof error.message === "string";

const hasErrorName = (
  error: { name: unknown } | object
): error is { name: string } =>
  "name" in error && typeof error.name === "string";

const maybeHasErrorStack = (
  error: { stack?: unknown } | object
): error is { stack?: string } =>
  !("stack" in error) || typeof error.stack === "string";

const isErrorLike = (error: unknown): error is Error =>
  typeof error === "object" &&
  !isNullish(error) &&
  hasErrorMessage(error) &&
  hasErrorName(error) &&
  maybeHasErrorStack(error);

export const isError = (error: unknown): error is Error =>
  error instanceof Error || isErrorLike(error);
